export const optionsCountries = [
    { id: "United States", title: "United States" },
    { id: "afghanistan", title: "Afghanistan" },
    { id: "aland_islands", title: "Åland Islands" },
    { id: "albania", title: "Albania" },
    { id: "algeria", title: "Algeria" },
    { id: "american_samoa", title: "American Samoa" },
    { id: "andorra", title: "Andorra" },
    { id: "angola", title: "Angola" },
    { id: "anguilla", title: "Anguilla" },
    { id: "antarctica", title: "Antarctica" },
    { id: "antigua_and_barbuda", title: "Antigua and Barbuda" },
    { id: "argentina", title: "Argentina" },
    { id: "armenia", title: "Armenia" },
    { id: "aruba", title: "Aruba" },
    { id: "australia", title: "Australia" },
    { id: "austria", title: "Austria" },
    { id: "azerbaijan", title: "Azerbaijan" },
    { id: "bahamas", title: "Bahamas" },
    { id: "bahrain", title: "Bahrain" },
    { id: "bangladesh", title: "Bangladesh" },
    { id: "barbados", title: "Barbados" },
    { id: "belarus", title: "Belarus" },
    { id: "belgium", title: "Belgium" },
    { id: "belize", title: "Belize" },
    { id: "benin", title: "Benin" },
    { id: "bermuda", title: "Bermuda" },
    { id: "bhutan", title: "Bhutan" },
    { id: "bolivia", title: "Bolivia" },
    { id: "bonaire_sint_eustatius_and_saba", title: "Bonaire, Sint Eustatius and Saba" },
    { id: "bosnia_and_herzegovina", title: "Bosnia and Herzegovina" },
    { id: "botswana", title: "Botswana" },
    { id: "bouvet_island", title: "Bouvet Island" },
    { id: "brazil", title: "Brazil" },
    { id: "british_indian_ocean_territory", title: "British Indian Ocean Territory" },
    { id: "brunei", title: "Brunei" },
    { id: "bulgaria", title: "Bulgaria" },
    { id: "burkina_faso", title: "Burkina Faso" },
    { id: "burundi", title: "Burundi" },
    { id: "cabo_verde", title: "Cabo Verde" },
    { id: "cambodia", title: "Cambodia" },
    { id: "cameroon", title: "Cameroon" },
    { id: "canada", title: "Canada" },
    { id: "cape_verde", title: "Cape Verde" },
    { id: "cayman_islands", title: "Cayman Islands" },
    { id: "central_african_republic", title: "Central African Republic" },
    { id: "chad", title: "Chad" },
    { id: "chile", title: "Chile" },
    { id: "china", title: "China" },
    { id: "christmas_island", title: "Christmas Island" },
    { id: "cocos_keeling_islands", title: "Cocos (Keeling) Islands" },
    { id: "colombia", title: "Colombia" },
    { id: "comoros", title: "Comoros" },
    { id: "congo", title: "Congo" },
    { id: "congo_the_democratic_republic_of_the", title: "Congo (Democratic Republic of the)" },
    { id: "cook_islands", title: "Cook Islands" },
    { id: "costa_rica", title: "Costa Rica" },
    { id: "cote_divoire", title: "Côte d'Ivoire" },
    { id: "croatia", title: "Croatia" },
    { id: "cuba", title: "Cuba" },
    { id: "cura_ao", title: "Curaçao" },
    { id: "cyprus", title: "Cyprus" },
    { id: "czech_republic", title: "Czech Republic" },
    { id: "democratic_republic_of_the_congo", title: "Democratic Republic of the Congo" },
    { id: "denmark", title: "Denmark" },
    { id: "djibouti", title: "Djibouti" },
    { id: "dominica", title: "Dominica" },
    { id: "dominican_republic", title: "Dominican Republic" },
    { id: "ecuador", title: "Ecuador" },
    { id: "egypt", title: "Egypt" },
    { id: "el_salvador", title: "El Salvador" },
    { id: "equatorial_guinea", title: "Equatorial Guinea" },
    { id: "eritrea", title: "Eritrea" },
    { id: "estonia", title: "Estonia" },
    { id: "eswatini", title: "Eswatini" },
    { id: "ethiopia", title: "Ethiopia" },
    { id: "falkland_islands_malvinas", title: "Falkland Islands (Malvinas)" },
    { id: "faroe_islands", title: "Faroe Islands" },
    { id: "fiji", title: "Fiji" },
    { id: "finland", title: "Finland" },
    { id: "france", title: "France" },
    { id: "french_guiana", title: "French Guiana" },
    { id: "french_polynesia", title: "French Polynesia" },
    { id: "french_southern_territories", title: "French Southern Territories" },
    { id: "gabon", title: "Gabon" },
    { id: "gambia", title: "Gambia" },
    { id: "georgia", title: "Georgia" },
    { id: "germany", title: "Germany" },
    { id: "ghana", title: "Ghana" },
    { id: "gibraltar", title: "Gibraltar" },
    { id: "greece", title: "Greece" },
    { id: "greenland", title: "Greenland" },
    { id: "grenada", title: "Grenada" },
    { id: "guadeloupe", title: "Guadeloupe" },
    { id: "guatemala", title: "Guatemala" },
    { id: "guernsey", title: "Guernsey" },
    { id: "guinea", title: "Guinea" },
    { id: "guinea_bissau", title: "Guinea-Bissau" },
    { id: "guyana", title: "Guyana" },
    { id: "haiti", title: "Haiti" },
    { id: "heard_island_and_mcdonald_islands", title: "Heard Island and McDonald Islands" },
    { id: "holy_see_vatican_city_state", title: "Holy See (Vatican City State)" },
    { id: "honduras", title: "Honduras" },
    { id: "hong_kong", title: "Hong Kong" },
    { id: "hungary", title: "Hungary" },
    { id: "iceland", title: "Iceland" },
    { id: "india", title: "India" },
    { id: "indonesia", title: "Indonesia" },
    { id: "iran", title: "Iran" },
    { id: "iraq", title: "Iraq" },
    { id: "ireland", title: "Ireland" },
    { id: "isle_of_man", title: "Isle of Man" },
    { id: "israel", title: "Israel" },
    { id: "italy", title: "Italy" },
    { id: "jamaica", title: "Jamaica" },
    { id: "japan", title: "Japan" },
    { id: "jersey", title: "Jersey" },
    { id: "jordan", title: "Jordan" },
    { id: "kazakhstan", title: "Kazakhstan" },
    { id: "kenya", title: "Kenya" },
    { id: "kiribati", title: "Kiribati" },
    { id: "korea_democratic_peoples_republic_of", title: "Korea (Democratic People's Republic of)" },
    { id: "kosovo", title: "Kosovo" },
    { id: "kuwait", title: "Kuwait" },
    { id: "kyrgyzstan", title: "Kyrgyzstan" },
    { id: "lao_peoples_democratic_republic", title: "Lao People's Democratic Republic" },
    { id: "laos", title: "Laos" },
    { id: "latvia", title: "Latvia" },
    { id: "lebanon", title: "Lebanon" },
    { id: "lesotho", title: "Lesotho" },
    { id: "liberia", title: "Liberia" },
    { id: "libya", title: "Libya" },
    { id: "liechtenstein", title: "Liechtenstein" },
    { id: "lithuania", title: "Lithuania" },
    { id: "luxembourg", title: "Luxembourg" },
    { id: "macao", title: "Macao" },
    { id: "madagascar", title: "Madagascar" },
    { id: "malawi", title: "Malawi" },
    { id: "malaysia", title: "Malaysia" },
    { id: "maldives", title: "Maldives" },
    { id: "mali", title: "Mali" },
    { id: "malta", title: "Malta" },
    { id: "marshall_islands", title: "Marshall Islands" },
    { id: "martinique", title: "Martinique" },
    { id: "mauritania", title: "Mauritania" },
    { id: "mauritius", title: "Mauritius" },
    { id: "mayotte", title: "Mayotte" },
    { id: "mexico", title: "Mexico" },
    { id: "micronesia", title: "Micronesia" },
    { id: "moldova", title: "Moldova" },
    { id: "monaco", title: "Monaco" },
    { id: "mongolia", title: "Mongolia" },
    { id: "montenegro", title: "Montenegro" },
    { id: "montserrat", title: "Montserrat" },
    { id: "morocco", title: "Morocco" },
    { id: "mozambique", title: "Mozambique" },
    { id: "myanmar", title: "Myanmar" },
    { id: "namibia", title: "Namibia" },
    { id: "nauru", title: "Nauru" },
    { id: "nepal", title: "Nepal" },
    { id: "netherlands", title: "Netherlands" },
    { id: "new_caledonia", title: "New Caledonia" },
    { id: "new_zealand", title: "New Zealand" },
    { id: "nicaragua", title: "Nicaragua" },
    { id: "niger", title: "Niger" },
    { id: "nigeria", title: "Nigeria" },
    { id: "niue", title: "Niue" },
    { id: "norfolk_island", title: "Norfolk Island" },
    { id: "north_korea", title: "North Korea" },
    { id: "north_macedonia", title: "North Macedonia" },
    { id: "norway", title: "Norway" },
    { id: "oman", title: "Oman" },
    { id: "pakistan", title: "Pakistan" },
    { id: "palau", title: "Palau" },
    { id: "palestine", title: "Palestine" },
    { id: "palestinian_territory", title: "Palestinian Territory" },
    { id: "panama", title: "Panama" },
    { id: "papua_new_guinea", title: "Papua New Guinea" },
    { id: "paraguay", title: "Paraguay" },
    { id: "peru", title: "Peru" },
    { id: "philippines", title: "Philippines" },
    { id: "pitcairn", title: "Pitcairn" },
    { id: "poland", title: "Poland" },
    { id: "portugal", title: "Portugal" },
    { id: "puerto_rico", title: "Puerto Rico" },
    { id: "qatar", title: "Qatar" },
    { id: "reunion", title: "Réunion" },
    { id: "romania", title: "Romania" },
    { id: "russia", title: "Russia" },
    { id: "rwanda", title: "Rwanda" },
    { id: "saint_barth_lemy", title: "Saint Barthélemy" },
    { id: "saint_helena", title: "Saint Helena" },
    { id: "saint_kitts_and_nevis", title: "Saint Kitts and Nevis" },
    { id: "saint_lucia", title: "Saint Lucia" },
    { id: "saint_martin_french_part", title: "Saint Martin (French Part)" },
    { id: "saint_pierre_and_miquelon", title: "Saint Pierre and Miquelon" },
    { id: "saint_vincent_and_the_grenadines", title: "Saint Vincent and the Grenadines" },
    { id: "samoa", title: "Samoa" },
    { id: "san_marino", title: "San Marino" },
    { id: "sao_tome_and_principe", title: "São Tomé and Príncipe" },
    { id: "saudi_arabia", title: "Saudi Arabia" },
    { id: "senegal", title: "Senegal" },
    { id: "serbia", title: "Serbia" },
    { id: "seychelles", title: "Seychelles" },
    { id: "sierra_leone", title: "Sierra Leone" },
    { id: "singapore", title: "Singapore" },
    { id: "sint_maarten_dutch_part", title: "Sint Maarten (Dutch Part)" },
    { id: "slovakia", title: "Slovakia" },
    { id: "slovenia", title: "Slovenia" },
    { id: "solomon_islands", title: "Solomon Islands" },
    { id: "somalia", title: "Somalia" },
    { id: "south_africa", title: "South Africa" },
    { id: "south_georgia_and_the_south_sandwich_islands", title: "South Georgia and the South Sandwich Islands" },
    { id: "south_korea", title: "South Korea" },
    { id: "south_sudan", title: "South Sudan" },
    { id: "spain", title: "Spain" },
    { id: "sri_lanka", title: "Sri Lanka" },
    { id: "sudan", title: "Sudan" },
    { id: "suriname", title: "Suriname" },
    { id: "svalbard_and_jan_mayen", title: "Svalbard and Jan Mayen" },
    { id: "swaziland", title: "Swaziland" },
    { id: "sweden", title: "Sweden" },
    { id: "switzerland", title: "Switzerland" },
    { id: "syria", title: "Syria" },
    { id: "taipei", title: "Taipei" },
    { id: "taiwan", title: "Taiwan" },
    { id: "tajikistan", title: "Tajikistan" },
    { id: "tanzania", title: "Tanzania" },
    { id: "thailand", title: "Thailand" },
    { id: "timor_leste", title: "Timor-Leste" },
    { id: "togo", title: "Togo" },
    { id: "tokelau", title: "Tokelau" },
    { id: "tonga", title: "Tonga" },
    { id: "trinidad_and_tobago", title: "Trinidad and Tobago" },
    { id: "tunisia", title: "Tunisia" },
    { id: "turkey", title: "Turkey" },
    { id: "turkmenistan", title: "Turkmenistan" },
    { id: "turks_and_caicos_islands", title: "Turks and Caicos Islands" },
    { id: "tuvalu", title: "Tuvalu" },
    { id: "uganda", title: "Uganda" },
    { id: "ukraine", title: "Ukraine" },
    { id: "united_arab_emirates", title: "United Arab Emirates" },
    { id: "united_kingdom", title: "United Kingdom" },
    { id: "uruguay", title: "Uruguay" },
    { id: "uzbekistan", title: "Uzbekistan" },
    { id: "vanuatu", title: "Vanuatu" },
    { id: "vatican_city", title: "Vatican City" },
    { id: "venezuela", title: "Venezuela" },
    { id: "vietnam", title: "Vietnam" },
    { id: "virgin_islands_british", title: "Virgin Islands (British)" },
    { id: "wallis_and_futuna", title: "Wallis and Futuna" },
    { id: "western_sahara", title: "Western Sahara" },
    { id: "yemen", title: "Yemen" },
    { id: "zambia", title: "Zambia" },
    { id: "zimbabwe", title: "Zimbabwe" },
];

export const optionsUsaStates = [
    { id: "alabama", title: "Alabama" },
    { id: "alaska", title: "Alaska" },
    { id: "arizona", title: "Arizona" },
    { id: "arkansas", title: "Arkansas" },
    { id: "california", title: "California" },
    { id: "colorado", title: "Colorado" },
    { id: "connecticut", title: "Connecticut" },
    { id: "delaware", title: "Delaware" },
    { id: "District of Columbia", title: "District of Columbia" },
    { id: "florida", title: "Florida" },
    { id: "georgia", title: "Georgia" },
    { id: "hawaii", title: "Hawaii" },
    { id: "idaho", title: "Idaho" },
    { id: "illinois", title: "Illinois" },
    { id: "indiana", title: "Indiana" },
    { id: "iowa", title: "Iowa" },
    { id: "kansas", title: "Kansas" },
    { id: "kentucky", title: "Kentucky" },
    { id: "louisiana", title: "Louisiana" },
    { id: "maine", title: "Maine" },
    { id: "maryland", title: "Maryland" },
    { id: "massachusetts", title: "Massachusetts" },
    { id: "michigan", title: "Michigan" },
    { id: "minnesota", title: "Minnesota" },
    { id: "mississippi", title: "Mississippi" },
    { id: "missouri", title: "Missouri" },
    { id: "montana", title: "Montana" },
    { id: "nebraska", title: "Nebraska" },
    { id: "nevada", title: "Nevada" },
    { id: "new_hampshire", title: "New Hampshire" },
    { id: "new_jersey", title: "New Jersey" },
    { id: "new_mexico", title: "New Mexico" },
    { id: "new_york", title: "New York" },
    { id: "north_carolina", title: "North Carolina" },
    { id: "north_dakota", title: "North Dakota" },
    { id: "ohio", title: "Ohio" },
    { id: "oklahoma", title: "Oklahoma" },
    { id: "oregon", title: "Oregon" },
    { id: "pennsylvania", title: "Pennsylvania" },
    { id: "rhode_island", title: "Rhode Island" },
    { id: "south_carolina", title: "South Carolina" },
    { id: "south_dakota", title: "South Dakota" },
    { id: "tennessee", title: "Tennessee" },
    { id: "texas", title: "Texas" },
    { id: "utah", title: "Utah" },
    { id: "vermont", title: "Vermont" },
    { id: "virginia", title: "Virginia" },
    { id: "washington", title: "Washington" },
    { id: "west_virginia", title: "West Virginia" },
    { id: "wisconsin", title: "Wisconsin" },
    { id: "wyoming", title: "Wyoming" }
];
export const optionsGermanyZipcodes = [
    { id: "1067 - Dresden (Saxony)", title: "1067 - Dresden (Saxony)" },
    { id: "10115 - Berlin (Berlin)", title: "10115 - Berlin (Berlin)" },
    { id: "20095 - Hamburg (Hamburg)", title: "20095 - Hamburg (Hamburg)" },
    { id: "28195 - Bremen (Bremen)", title: "28195 - Bremen (Bremen)" },
    { id: "30159 - Hannover (Lower Saxony)", title: "30159 - Hannover (Lower Saxony)" },
    { id: "34117 - Kassel (Hesse)", title: "34117 - Kassel (Hesse)" },
    { id: "38100 - Braunschweig (Lower Saxony)", title: "38100 - Braunschweig (Lower Saxony)" },
    { id: "40213 - Düsseldorf (North Rhine-Westphalia)", title: "40213 - Düsseldorf (North Rhine-Westphalia)" },
    { id: "44135 - Dortmund (North Rhine-Westphalia)", title: "44135 - Dortmund (North Rhine-Westphalia)" },
    { id: "50667 - Köln (North Rhine-Westphalia)", title: "50667 - Köln (North Rhine-Westphalia)" },
    { id: "60311 - Frankfurt am Main (Hesse)", title: "60311 - Frankfurt am Main (Hesse)" },
    { id: "65183 - Wiesbaden (Hesse)", title: "65183 - Wiesbaden (Hesse)" },
    { id: "70173 - Stuttgart (Baden-Württemberg)", title: "70173 - Stuttgart (Baden-Württemberg)" },
    { id: "80331 - München (Bavaria)", title: "80331 - München (Bavaria)" },
    { id: "85049 - Ingolstadt (Bavaria)", title: "85049 - Ingolstadt (Bavaria)" },
    { id: "90402 - Nürnberg (Bavaria)", title: "90402 - Nürnberg (Bavaria)" },
    { id: "99084 - Erfurt (Thuringia)", title: "99084 - Erfurt (Thuringia)" },
]

export const optionsStates = [
    { id: 1, title: 'AC', name: 'Acre' },
    { id: 2, title: 'AL', name: 'Alagoas' },
    { id: 3, title: 'AP', name: 'Amapa' },
    { id: 4, title: 'AM', name: 'Amazonas' },

    { id: 5, title: 'BA', name: 'Bahia' },
    { id: 6, title: 'CE', name: 'Ceara' },
    { id: 7, title: 'DF', name: 'Distrito Federal' },
    { id: 8, title: 'ES', name: 'Espirito Santo' },
    { id: 9, title: 'GO', name: 'Goias' },
    { id: 10, title: 'MA', name: 'Maranhão' },

    { id: 11, title: 'MT', name: 'Mato Grosso' },
    { id: 12, title: 'MS', name: 'Mato Grosso do Sul' },
    { id: 13, title: 'MG', name: 'Minas Gerias' },
    { id: 14, title: 'PA', name: 'Pará' },
    { id: 15, title: 'PB', name: 'Paraíba' },

    { id: 16, title: 'PR', name: 'Paraná' },
    { id: 17, title: 'PE', name: 'Pernambuco' },
    { id: 18, title: 'PI', name: 'Piauí' },
    { id: 19, title: 'RJ', name: 'Rio de Janeiro' },

    { id: 20, title: 'RN', name: 'Rio Grande do Norte' },
    { id: 21, title: 'RS', name: 'Rio Grande do Sul' },
    { id: 22, title: 'RO', name: 'Rondônia' },
    { id: 23, title: 'RR', name: 'Roraima' },

    { id: 24, title: 'SC', name: 'Santa Catarina' },
    { id: 25, title: 'SP', name: 'São Paulo' },
    { id: 26, title: 'SE', name: 'Sergipe' },
    { id: 27, title: 'TO', name: 'Tocântins' },
];

export const countries = [
    { code: "US", label: "United States", phone: "1", emoji: "🇺🇸" },
    { code: "BR", label: "Brazil", phone: "55", emoji: "🇧🇷" },
    { code: "GB", label: "United Kingdom", phone: "44", emoji: "🇬🇧" },
    { code: "DE", label: "Germany", phone: "49", emoji: "🇩🇪" },
    { code: "FR", label: "France", phone: "33", emoji: "🇫🇷" },
    { code: "AU", label: "Australia", phone: "61", emoji: "🇦🇺" }
];


export const languages = [
    { id: "English", title: "English", name: "ENG - English", ref: "en" },
    { id: "Portuguese", title: "Português", name: "Português", ref: "pt-BR" },
    { id: "German", title: "German", name: "German", ref: "de" },

    { id: "Spanish", title: "Español", name: "Español", ref: "es" },
    { id: "Chinese", title: "中文", name: "Chinese", ref: "zh" },
    { id: "Japanese", title: "日本語", name: "Japanese", ref: "ja" },
    { id: "Hindi", title: "हिन्दी", name: "Hindi", ref: "hi" },
];


export const optionsLanguage = [
    { id: 'English', title: 'English', image: '/images/flags/English.png' },
    { id: 'French', title: 'French', image: '/images/flags/French.jpg' },
    { id: 'German', title: 'German', image: '/images/flags/German.png' },
    { id: 'Spanish', title: 'Spanish', image: '/images/flags/Spanish.png' },
    { id: 'Russian', title: 'Russian', image: '/images/flags/Russian.png' },
    { id: 'Arabic', title: 'Arabic', image: '/images/flags/Arabic.png' },
    { id: 'Italian', title: 'Italian', image: '/images/flags/Italian.png' },
    { id: 'Portuguese', title: 'Portuguese', image: '/images/flags/portuguese.svg' },
];

export const industryOptions = [
    { id: "diagnostic", title: "Diagnostic" },
    { id: "neurology", title: "Neurology" },
    { id: "patient", title: "Patient" },
    { id: "psychiatry", title: "Psychiatry" },
    { id: "psychology", title: "Psychology" },
    { id: "research", title: "Research" },
    { id: "pain", title: "Pain" },
    { id: "therapy", title: "Therapy" },
    { id: "physiotherapy", title: "Physiotherapy" },
    { id: "neurosurgery", title: "Neurosurgery" },
    { id: "general_practice", title: "General Practice" },
    { id: "related_stakeholders", title: "Related Stakeholders" },
    { id: "other", title: "Partner/Distributor" },
];
export const tableOptions = [
    { id: "marketing-materials", title: "Marketing materials" },
    { id: "service-supports", title: "Service & Support" },
    { id: "product-informations", title: "Product information" },
    { id: "support-materials", title: "Practice Support Materials" },
];

export const optionsSalutation = [
    { id: "mr", title: "Mr." },
    { id: "ms", title: "Ms." },
    { id: "mrs", title: "Mrs." },
    { id: "dr", title: "Dr." },
    { id: "professor", title: "Professor" },
    { id: "md", title: "MD" },
    { id: "frau", title: "Frau" },
    { id: "herr", title: "Herr" },
    { id: "dra", title: "Dra." },
    { id: "profa", title: "Profa." },
    { id: "sr", title: "Sr." },
    { id: "sra", title: "Sra." },
    { id: "xiansheng", title: "先生" },
    { id: "nüshi", title: "女士" },
    { id: "frau_dr", title: "Frau Dr." },
    { id: "herr_dr", title: "Herr Dr." },
    { id: "professor_dr", title: "Professor Dr. " },
];

export const shareDayOptions = [
    { id: 7, title: '7' },
    { id: 10, title: '10' },
    { id: 20, title: '20' },
    { id: 30, title: '30' },
]
